import * as z from "zod";
import { requiredString } from "components/form/utils";

export const countrySchema = z.object({
  name: requiredString(),
});
